document.addEventListener('DOMContentLoaded', function() {
    var body = document.querySelector('body');
    var mainContent = document.querySelector('main');
    var modal = document.getElementById('adult-check-modal');
    var confirmBtn = document.getElementById('confirm-age');
    var denyBtn = document.getElementById('deny-age');

    if( modal ) {
        body.classList.add('scroll-lock');
        mainContent.classList.add('blur-background');

        // Check if user has already made a choice
        if (getCookie('adultConfirmed') !== 'true') {
            modal.style.display = 'block';
            mainContent.classList.add('blur-background');
            confirmBtn.focus();     
        }

        // user is 18 or older
        confirmBtn.addEventListener('click', function() {
            modal.style.display = 'none';
            body.classList.remove('scroll-lock');
            mainContent.classList.remove('blur-background');
            
            // setCookie('adultConfirmed', 'true', 30); // Set cookie for 30 days
        });

        // user is under 18
        denyBtn.addEventListener('click', function() {
            // redirect user back to the gallery home page
            const galleryHome = '/' + new URL(location.href).pathname.split("/")[1] + '/';
            window.location.href = galleryHome;
        });   
    }
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}